/**
 * ElementStatsWidget - Widget Wrapper
 *
 * Обёртка для ElementStatsChart с управлением состоянием.
 * Используется на странице Reports.
 */

import React, { useState } from 'react';
import { Card, Title, Group, Text } from '@mantine/core';
import { IconChartBar } from '@tabler/icons-react';
import ElementStatsChart from '../../Charts/ElementStatsChart';
import { ELEMENT_TYPES } from '../../../constants/elementTypes';
import tokens from '../../../theme/designTokens';

const ElementStatsWidget = () => {
  const [period, setPeriod] = useState('month');
  const [granularity, setGranularity] = useState('daily');
  const [visibleTypes, setVisibleTypes] = useState(
    ELEMENT_TYPES.map((t) => t.code)
  );

  const handleTypeToggle = (typeCode) => {
    setVisibleTypes((prev) =>
      prev.includes(typeCode)
        ? prev.filter((t) => t !== typeCode)
        : [...prev, typeCode]
    );
  };

  const handleSelectAll = (selectAll) => {
    if (selectAll) {
      setVisibleTypes(ELEMENT_TYPES.map((t) => t.code));
    } else {
      setVisibleTypes([]);
    }
  };

  return (
    <Card
      shadow="sm"
      radius={16}
      withBorder
      p="lg"
      style={{ border: `1px solid ${tokens.colors.neutral[3]}` }}
    >
      {/* Заголовок виджета */}
      <Group gap="sm" mb="md">
        <IconChartBar
          size={24}
          style={{ color: tokens.colors.brand.primary }}
        />
        <div>
          <Title order={4} style={{ color: tokens.colors.neutral[9] }}>
            Статистика по элементам
          </Title>
          <Text size="xs" c="dimmed">
            Количество созданных элементов за период
          </Text>
        </div>
      </Group>

      {/* Core Component */}
      <ElementStatsChart
        period={period}
        granularity={granularity}
        visibleTypes={visibleTypes}
        onPeriodChange={setPeriod}
        onGranularityChange={setGranularity}
        onTypeToggle={handleTypeToggle}
        onSelectAll={handleSelectAll}
        height={350}
      />
    </Card>
  );
};

export default ElementStatsWidget;
